/*
 * IMPORTS
 */
import React, { useState } from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { toast } from 'react-hot-toast' // Npm: React hot toast.
import { useMutation } from '@apollo/client' // Npm: Apollo client.
import { Flex, Text, useBreakpointValue, Button, Modal, ModalOverlay, ModalContent, ModalBody } from '@chakra-ui/react' // Npm: Chakra UI.

/*
 * PACKAGES
 */
import { MemoizedSelect } from 'components/MemoizedInput'
import DeleteCard from 'components/DeleteCard'

/*
 * GRAPHS
 */
import DataCleanMutation from './__mutation__/index.dataclean.mutation'

/*
 * OBJECTS
 */
const Index = ({ title }) => {
  // State assignment.
  const [tableName, setTableName] = useState("")
  const [showDelete, setShowDelete] = useState(false)

  // Hook assignment 
  const _isCurrentViewMobile = useBreakpointValue(
    { base: true, sm: true, md: false, lg: false, xl: false },
    { fallback: 'base', ssr: true }
  )
  const [MutationDataClean, MutationDataCleanResponse] = useMutation(DataCleanMutation)

  // Return Component.
  return (
    <>
      <Flex
        w="100%"
        borderRadius="20px"
        p={_isCurrentViewMobile ? '14px' : '24px'}
        background="linear-gradient(23deg, #FFDBE7 0%, #BCC0FF 99.80%)"
        boxShadow="14px 17px 40px 4px rgba(112, 144, 176, 0.17)"
        flexDirection="column"
        gap={_isCurrentViewMobile ? '16px' : '20px'}
      >
        <Flex
          w="100%"
          alignItems="center"
          justifyContent="space-between"
          flexWrap={_isCurrentViewMobile ? "wrap" : "nowrap"}
          gap="14px"
        >
          <Flex direction="column">
            <Text
              color='rgba(43,54,116,1)'
              ml="10px"
              fontWeight='700'
              fontSize="18px"
              textAlign='left'
            >
              {title}
            </Text>

            <Text
              ml="10px"
              fontSize="14px"
              color="rgba(141, 151, 182, 1)"
              fontWeight="500"
            >
              from the selected table
            </Text>
          </Flex>
          <Flex
            flex="1"
            alignItems="center"
            justifyContent={{ base: "space-between", md: "flex-end" }}
            gap={{ base: "10px", md: "16px" }}
            flexWrap="nowrap"
            color='rgba(43,54,116,1)'

          >
            <MemoizedSelect
              flex={1}
              w={_isCurrentViewMobile ? "100%" : "auto"}
              color='rgba(43,54,116,1)'
              placeholder="Select table"
              options={Object.React.App.enums.TABLE_LIST.enums.map(tbl => ({
                label: tbl.key,
                value: tbl.key
              }))}
              data={tableName}
              onChange={(e) => setTableName(e?.target?.value || e?.value || e)}
              isDisabled={MutationDataCleanResponse.loading}
              fontSize="13px"
              fontWeight={600}
              height="34px"
              borderRadius="2xl"
              bg="#ffffff"
              sx={{
                "& option": { fontSize: "14px", color: "black" }
              }}
            />

            <Button
              height="34px"
              px={6}
              fontSize="12px"
              color="white"
              background="red.500"
              borderRadius="2xl"
              isDisabled={!tableName || MutationDataCleanResponse.loading}
              _hover={{ bg: 'red.600', transform: "scale(1.02)" }}
              onClick={() => setShowDelete(true)}
              w={_isCurrentViewMobile ? "100%" : "auto"}
            >
              DELETE
            </Button>
          </Flex>
        </Flex>
      </Flex>

      <Modal isOpen={showDelete} onClose={() => !MutationDataCleanResponse.loading && setShowDelete(false)} isCentered closeOnOverlayClick={!MutationDataCleanResponse.loading}>
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <DeleteCard onClose={() => setShowDelete(false)} disabled={MutationDataCleanResponse.loading} onConfirm={() => MutationDataClean({ 'variables': { tableName } }).then(i => { toast(i?.data?.DataClean?.message); setTableName(""); return setShowDelete(false) }).catch(() => toast('Something went wrong please try after some time.'))} isLoading={MutationDataCleanResponse.loading} subHeading={`Delete all records from ${tableName}`} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

/*
 * PROPTYPES
 */
Index.propTypes = {
  'title': PropTypes.string
}

/*
 * EXPORT
 */
export default Index
